
const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export async function fetchCarburantList(params: {
  id_user: number | null;
  page: number;
  limit: number;
  search: string;
  sortColumn: string;
  sortDir: "ASC" | "DESC";

  // ✅ NEW (optional): tell backend which field user chose in UI
  // backend must support it to avoid "search everything"
  filterKey?: string; // "utilisateur" | "vehicule" | ...
}) {
  const { id_user, page, limit, search, sortColumn, sortDir, filterKey } = params;

  const url = new URL(`${backendUrl}/api/carburant/list/${id_user ?? "null"}`);
  url.searchParams.set("page", String(page));
  url.searchParams.set("limit", String(limit));
  url.searchParams.set("search", search || "");
  url.searchParams.set("sortColumn", sortColumn);
  url.searchParams.set("sortDir", sortDir);

  // ✅ send filterKey if provided (backend can ignore if not implemented)
  if (filterKey) url.searchParams.set("filterKey", filterKey);

  const res = await fetch(url.toString(), { credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.message || "Failed to load carburant");
  return data;
}

export async function createCarburant(payload: any) {
  const res = await fetch(`${backendUrl}/api/carburant`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.message || "Failed to create carburant");
  return data;
}

export async function updateCarburant(id: number, payload: any) {
  const res = await fetch(`${backendUrl}/api/carburant/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.message || "Failed to update carburant");
  return data;
}

export async function deleteCarburant(id: number) {
  const res = await fetch(`${backendUrl}/api/carburant/${id}`, {
    method: "DELETE",
    credentials: "include",
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.message || "Failed to delete carburant");
  return data;
}

export async function importCarburantFile(id_user: number, file: File) {
  const fd = new FormData();
  fd.append("file", file);

  const res = await fetch(`${backendUrl}/api/carburant/import/${id_user}`, {
    method: "POST",
    credentials: "include",
    body: fd,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.message || "Failed to import carburant");
  return data;
}


